import axios from "axios";

import { initCommonSettings } from "@krea/customer-features/settings";

const settings = initCommonSettings({
  unauthorizedPaths: [
    "/login",
    "/delegated-information",
    "/identify",
    "/identify/success",
    "/direct/loan-application-form",
    "/direct/factoring-application-form",
    "/amount-estimator",
    "/eligibility-check",
    "/direct/real-estate-application-form",
    "/direct/leasing-application-form",
    "/application",
  ],
});

// Set global axios config
axios.defaults.baseURL = settings.backendBaseUrl;
axios.defaults.withCredentials = false;
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

// eslint-disable-next-line import/no-default-export
export default settings;
